import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Sliders03 = function Sliders03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15.0505 9H5.5C4.1193 9 3 7.8807 3 6.5S4.1193 4 5.5 4h9.5505m-6.101 16H18.5c1.3807 0 2.5-1.1193 2.5-2.5S19.8807 15 18.5 15H8.9495M3 17.5C3 19.433 4.567 21 6.5 21s3.5-1.567 3.5-3.5S8.433 14 6.5 14 3 15.567 3 17.5m18-11c0 1.933-1.567 3.5-3.5 3.5S14 8.433 14 6.5 15.567 3 17.5 3 21 4.567 21 6.5"
    })
  }));
};
export default Sliders03;